import React from 'react';
import AppButton from "@common/components/app-button";
import {useSpecialistForm} from "../hooks/use-specialist-form.hook";
import {FormProvider} from "react-hook-form";
import {SpecialistFormProvider} from "../contexts/specialist-form-context";
import TextFormField from "@common/components/forms/text-form-field";
import ImageUploadFormField from "@common/components/forms/image-upload-form-field";
import PhoneFormField from "./phone-form-field";
import {UniversalClickHandler} from "@common/models/types/universal-click-handler.type";
import ImageCropperModal from "../../core/components/image-cropper-modal";

interface SpecialistFormProps {
    specialistId?: string;
    onCancel?: () => void;
    onSuccess?: UniversalClickHandler;
}

const SpecialistFormContent: React.FC<SpecialistFormProps> = (props: SpecialistFormProps) => {
    const {onCancel, onSuccess} = props;
    const {isEditMode, isLoading, saveSpecialist, form} = useSpecialistForm();

    const onSubmit = async () => {
        await saveSpecialist();
        onSuccess && onSuccess();
    };

    if (isLoading && isEditMode && !form.getValues().id) {
        return (
            <div className="flex items-center justify-center p-8">
                <div className="text-on-surface/60">Ładowanie...</div>
            </div>
        );
    }

    return (
        <FormProvider {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">

                <div className="space-y-6 overflow-y-auto px-[3px] pb-[2px]">
                    <div className="flex justify-center">
                        <ImageUploadFormField
                            name="image"
                            label=""
                            maxSize={5}
                            acceptedTypes={['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/jpg']}
                        />
                    </div>

                    <div className="space-y-4">
                        <TextFormField
                            name="fullName"
                            label="Imię i nazwisko"
                            type="text"
                            isRequired={true}
                            placeholder="Imię i nazwisko"
                        />

                        <TextFormField
                            name="specialization"
                            label="Specjalizacja"
                            type="text"
                            isRequired={true}
                            placeholder="Specjalizacja"
                        />

                        <TextFormField
                            name="websiteUrl"
                            label="Link do strony"
                            type="url"
                            isRequired={true}
                            placeholder="Link do strony"
                        />

                        <PhoneFormField
                            name="phoneNumber"
                            label="Numer telefonu do rejestracji"
                            isRequired={true}
                        />

                        <TextFormField
                            name="znanyLekarzUrl"
                            label="Link do Znany Lekarz"
                            type="url"
                            placeholder="Link do Znany Lekarz"
                        />
                    </div>
                </div>

                <div className="flex items-center gap-3 justify-end h-[72px] max-[72px]">
                    <AppButton
                        type={"button"}
                        onClick={onCancel}
                        className="bg-transparent max-h-[40px] h-[40px] !px-6 !pt-2 border-[2px] !border-on-surface font-semibold text-base !rounded-full hover:bg-on-surface/5"
                        label="Anuluj"
                    />
                    <AppButton
                        disabled={isLoading}
                        loading={isLoading}
                        className="bg-primary max-h-[40px] h-[40px] !px-6 !pt-2 text-on-primary font-semibold text-base !rounded-full hover:bg-primary/80"
                        label="Zapisz"
                    />
                </div>
            </form>
        </FormProvider>
    );
};

const SpecialistForm: React.FC<SpecialistFormProps> = (props: SpecialistFormProps) => {
    const {specialistId} = props;

    return (
        <SpecialistFormProvider specialistId={specialistId}>
            <SpecialistFormContent {...props}/>
            <ImageCropperModal/>
        </SpecialistFormProvider>
    );
};

export default SpecialistForm;
